module.exports = __webpack_public_path__ + "static/media/2.aedffd64.png";